/* eslint-disable import/no-mutable-exports */
import React, { useContext, useEffect, useState } from 'react';
import styles from './DialogNode.module.css';

import ContextWatson from '../../../context/WatsonContext';
import ConditionPart from './DialogNodeConditionPart';
import Button from '../../@base/Button';

import DialogSlotsDTO from '../../../dto/DialogSlotsDTO';
import Input from '../../@base/Input';
import { calculeWidth } from './DialogNodeCondition';

export let allIntents = [];
export let allEntities = [];

const DialogoNodeSlot = (props) => {
  if (!props.slot) return <></>;

  const watsonContext = useContext(ContextWatson);

  const [slot, setSlot] = useState(props.slot);
  const [contextVariable, setContextVariable] = useState(props.slot.contextVariable);
  const [defaultAsk, setDefaultAsk] = useState(props.slot.output.values[0]);

  allIntents = Object.values(watsonContext.intents).map((i) => ({ id: i.id, name: i.name }));
  allEntities = Object.values(watsonContext.entities).map((i) => ({
    id: i.id,
    name: i.name,
    values: i.values,
  }));

  const onBlurContextVariableChange = () => {
    const slotChanged = {
      ...slot,
      contextVariable,
    };
    setSlot(slotChanged);
  };

  const onBlurDefaultAskChange = () => {
    const slotChanged = {
      ...slot,
      output: {
        ...slot.output,
        values: [defaultAsk],
      },
    };
    setSlot(slotChanged);
  };

  const handleContextVariableChange = (e) => {
    setContextVariable(e.target.value);
  };

  const handleDefaultAskChange = (e) => {
    setDefaultAsk(e.target.value);
  };

  const setCondition = (condition) => {
    const slotChanged = {
      ...slot,
      condition,
    };

    setSlot(slotChanged);
  };

  const commonConditionProps = {
    condition: slot.condition,
    setCondition,
  };

  useEffect(() => {
    if (slot) {
      const slotChanged = JSON.stringify(slot) !== JSON.stringify(props.slot);
      if (slotChanged) props.updateSlot(slot);
    }
  }, [slot]);

  useEffect(() => {
    setSlot(props.slot);
  }, [props.slot]);

  return (
    <>
      <div className="item-list dialog-condition pb-0" style={{ borderWidth: '0' }}>
        <div className={styles.ConditionItem}>
          <div style={{ display: 'none' }} />
          <div className={styles.BlueHighlight}>Quando </div>
          <ConditionPart
            id="type"
            slotCondition
            {...commonConditionProps}
          />
          <ConditionPart
            id="object"
            {...commonConditionProps}
          />
          <ConditionPart
            id="logicalOperator"
            {...commonConditionProps}
          />
          <ConditionPart
            id="comparedValue"
            {...commonConditionProps}
          />
          <div className={styles.BlueHighlight}>salvar como </div>
          <Input
            placeholder="Digite um identificador"
            value={contextVariable}
            onChange={handleContextVariableChange}
            onBlur={onBlurContextVariableChange}
          />
        </div>

        <Button
          small
          circle
          disabled={props.removeDisabled}
          onClick={props.removeSlot}
          title={props.removeDisabled ? 'Para habilitar a remoção, termine de editar todos os coletores de informação' : ''}
        >
          <span><i className="fa fa-times" aria-hidden="true" /></span>
        </Button>
      </div>
      <div className="item-list dialog-condition mt-0">
        <div className={styles.ConditionItem}>
          <div style={{ display: 'none' }} />
          <div className={styles.BlueHighlight}>Se não, perguntar </div>
          <Input
            width={defaultAsk ? calculeWidth(defaultAsk) : 300}
            placeholder="Digite a pergunta"
            value={defaultAsk}
            onChange={handleDefaultAskChange}
            onBlur={onBlurDefaultAskChange}
          />
        </div>
      </div>

    </>
  );
};

const DialogoNodeSlotsController = (props) => {
  if (!props.slots) return <></>;

  const [slotsStatusValidation, setSlotsStatusValidation] = useState({});

  const moreHandler = () => {
    const newSlot = new DialogSlotsDTO();
    props.setDialogSlots([...props.slots, newSlot]);
  };

  const updateSlotHandler = (index, slot) => {
    const isValidSlot = DialogSlotsDTO.validate(slot);
    const statusSlotValidationChanged = {
      ...slotsStatusValidation,
      [index]: isValidSlot,
    };
    const isValidAllSlots = !Object.values(statusSlotValidationChanged).includes(false);
    setSlotsStatusValidation(statusSlotValidationChanged);

    if (isValidAllSlots) {
      const dialogSlots = [...props.slots];
      dialogSlots[index] = { ...slot };
      props.setDialogSlots(dialogSlots);
      props.save(dialogSlots);
    }
  };

  const removeSlotHandler = (index) => {
    let dialogSlots = [...props.slots];
    dialogSlots = dialogSlots.filter((c, i) => i !== index);
    props.setDialogSlots(dialogSlots);
    props.save(dialogSlots);
  };

  const isInValidSlots = Object.values(slotsStatusValidation).includes(false);

  return (
    <div>
      <div className={styles.DialogSubList}>
        {props.slots.map(
          (slot, index) => (
            <DialogoNodeSlot
              key={slot.id}
              slot={slot}
              removeDisabled={isInValidSlots || props.disabled}
              updateSlot={(_slot) => updateSlotHandler(index, _slot)}
              removeSlot={() => removeSlotHandler(index)}
              isInValidAnySlot={isInValidSlots}
            />
          ),
        )}
        {props.slots.length === 0 && (
          <div className={styles.WithoutConditions}>
            Adicione situações nas quais esse nó coletará informações.
          </div>
        )}

        <div>
          <Button
            small
            circle
            primary
            classes="more-item"
            onClick={moreHandler}
            disabled={props.disabled}
          >
            <i className="fa fa-plus" aria-hidden="true" />
          </Button>
        </div>
      </div>

    </div>
  );
};
export default DialogoNodeSlotsController;
